<template>
	<header class="border border-b bg-white flex flex-wrap justify-between items-center">
		<div class="header-container px-8 py-4">
			<router-link :to="{name:'AppProducts'}" @click="removeSelections" class="inline-block">
				<h1 class="flex items-center font-black">
					<span class="logo">
						<img src="@/assets/logo.svg" />
					</span>
					<span class="site-name text-3xl md:text-h1 uppercase font-black text-primary">Le panorama</span>
				</h1>
			</router-link>
		</div>
		<AppSearch />
	</header>
</template>

<script>
	// import store from '../store/index'
	import AppSearch from './AppSearch.vue'
    import store from '../store/index'
	export default {
		data(){},
		components:{ AppSearch },
        methods:{
            removeSelections() {
                console.log(store.state.query_params)
               store.dispatch('deleteQueryParams')
                console.log(store.state.query_params)
            }
        }
	}
</script>